// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","templateLabel":"CardTemplateToolbar_templateLabel__2QsCn"};